// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"handbook-preview-module--previewTitle--1iLES","tag":"handbook-preview-module--tag--35J6Y","submitButton":"handbook-preview-module--submitButton--2fE51"};